import React from "react";
import { getNavigator } from "./MainTab";
import intl from "react-intl-universal";

// 目前设计是filteredTabs >1 时才显示底部
export default function (currentIndex?: number) {
  const navigator = getNavigator();
  const { my = false, order = false } = navigator || {};

  const getTab1Name = function () {
    // 子相册页面是一定有dataDetail的
    if (!window.dataDetail) {
      return intl.get("Home");
    }
    if (Number(window.pageDetail.parent) == 0) {
      return intl.get("Home");
    }
    if (window.dataDetail.id == window.gallery.id) {
      return intl.get("LiveGallery");
    }
    // if (!Number(window.pageDetail.parent)) {
    //   return intl.get('Home');
    // }
    return intl.get("Back Home");
  };
  const tabs = [
    {
      id: 1, // id用来唯一标示一个tab
      active:
        getTab1Name() == intl.get("Back Home")
          ? require("../../svg/icon-back.svg")
          : require("../../svg/icon-home.svg"),
      inactive: require("../../svg/icon-back.svg"),
      name: getTab1Name(),
      show: true,
    },
    Number(window.configDetail.active_on)
      ? {
          id: 2,
          active: require("../../svg/icon-my-photos.svg"),
          inactive: require("../../svg/icon-my-photos-inactive.svg"),
          name: intl.get("MyPhoto"),
          show: !!+window.configDetail.use_face,
        }
      : null,
    Number(window.configDetail.active_on)
      ? {
          id: 3,
          active: require("../../svg/icon-followee.svg"),
          inactive: require("../../svg/icon-followee-inactive.svg"),
          name: intl.get("Following"),
          show: !!+window.configDetail.use_face,
        }
      : null,
    {
      id: 4,
      active: require("../../svg/icon-appointment.svg"),
      inactive: require("../../svg/icon-appointment-inactive.svg"),
      name: intl.get("Preorder"),
      show: order,
    },
    Number(window.configDetail.active_on)
      ? {
          id: 5,
          active: require("../../svg/icon-me.svg"),
          inactive: require("../../svg/icon-me-inactive.svg"),
          name: intl.get("My"),
          show: my,
        }
      : null,
  ].filter(Boolean);

  if (currentIndex && tabs[0]) {
    tabs[0].name =
      window.dataDetail?.id == window.gallery.id
        ? intl.get("Back Gallery")
        : intl.get("Back Home");
  }

  const filteredTabs = tabs.filter((tab) => tab && tab.show);
  const showNavigator = navigator && filteredTabs.length > 1;

  return {
    my,
    order,
    filteredTabs,
    showNavigator,
  };
}
